import { createContext } from 'react'

export type FontSize = 'small' | 'medium' | 'large' | 'extra-large'

export const FONT_SIZE_OPTIONS: { value: FontSize; label: string; scale: number }[] = [
  { value: 'small', label: 'Small', scale: 0.875 },
  { value: 'medium', label: 'Medium (Default)', scale: 1 },
  { value: 'large', label: 'Large', scale: 1.125 },
  { value: 'extra-large', label: 'Extra Large', scale: 1.25 },
]

export interface AccessibilityContextType {
  fontSize: FontSize
  setFontSize: (size: FontSize) => void
  highContrastMode: boolean
  setHighContrastMode: (enabled: boolean) => void
}

export const AccessibilityContext = createContext<AccessibilityContextType | undefined>(undefined)
